import { auth } from './db'
import router from '@/router'

export const signout = () => {
  auth.signOut().then(() => {
    router.push('/login')
  })
}